import { GET_ALL_CATEGORIES_AND_TYPES } from "../../enums/Request/request.types";

export const getAllRequestsAndTypes = (data) => {
   return  {
        type: GET_ALL_CATEGORIES_AND_TYPES,
        payload:data,
    }
}
